function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.43256 8.30416C0.43256 5.83385 0.281801 3.43781 0.0556641 0.964261H10.8191L11.1929 5.98885C12.3895 4.28708 15.3105 0.11499 22.9018 0.11499C31.6206 0.11499 34.0987 5.60458 34.8368 7.45489C37.9776 1.19676 43.1034 0.19249 47.0137 0.19249C54.6772 0.19249 57.7583 4.90708 58.5843 6.45062C60.6133 9.85093 60.4688 14.5623 60.4688 17.9626V39.3332H49.2782V17.052C49.2782 12.8799 48.6783 8.2428 42.8929 8.2428C36.203 8.2428 36.0523 14.656 36.0523 20.4523V39.3332H24.8553V16.8033C24.8553 13.7905 24.78 8.22666 18.6177 8.22666C11.6295 8.22666 11.6295 14.4105 11.6295 17.052V39.3332H0.43256V8.30416Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.0556641 47.9165H60.4782V57.4168H0.0556641V47.9165Z",
  fill: "black"
}));

function SvgMstable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMstable);
export default __webpack_public_path__ + "static/media/mstable.837044f9.svg";
export { ForwardRef as ReactComponent };